<template>
  <div class="container-fluid">
    <!-- page header -->
    <b-row class="mt-5 mb-3">
      <b-col sm="12" md="6">
        <h2>Mes rétroactions</h2>
        <p v-if="$route.params.type == 'grille'">
          Les rétroactions vous permettent d'éclaircir votre attribution de
          notes pour le participant et de faciliter votre communication avec
          lui.
        </p>
        <p v-else>
          Quand vous attribuez une rétroaction au commentaire du participant,
          une note liée à ce commentaire est générée. Au moment de faire
          l'évalutation finale, vous pouvez alors accepter cette note ou la
          modifier.
        </p>
      </b-col>
    </b-row>

    <b-nav pills>
      <div class="d-flex justify-content-between w-100">
        <div>
          <b-nav-item
            class="d-inline-block"
            :active="$route.params.type == 'grille'"
            :to="{ name: 'teachers.evaluations', params: { type: 'grille' } }"
            >Grille de critères</b-nav-item
          >
          <b-nav-item
            class="d-inline-block"
            :active="$route.params.type == 'messages'"
            :to="{ name: 'teachers.evaluations', params: { type: 'messages' } }"
            >Messages enregistrés</b-nav-item
          >
        </div>
        <b-btn
          v-if="$route.params.type == 'grille'"
          v-b-modal.newGridModal
          pill
          variant="info"
          class="text-white mb-2 pull-right"
        >
          <BIconPlus></BIconPlus>
          <span>Ajouter une nouvelle grille</span>
        </b-btn>
      </div>
    </b-nav>

    <component :is="activeRoute"></component>
    <NewGridModal />
  </div>
</template>

<script>
/**
 * @file       Teachers evaluations component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import store from "@/store";
import GridComment from "@/modules/grid/components/comment.vue";
import NewGridModal from "@/modules/grid/components/newGridModal.vue";
import PredefinedMessages from "@/modules/messages/components/predefinedMessages.vue";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "teacherEvaluations",
  components: { GridComment, NewGridModal, PredefinedMessages },


  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      tabIndex: 0
    };
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    activeRoute() {
      return this.$route.params.type == "grille"
        ? GridComment
        : PredefinedMessages;
    }
  },

  /**
   * Before route change.
   * 
   * @param  {string}   to     (Unused)
   * @param  {string}   from   (Unused)
   * @param  {Object}   next   The action
   */
  beforeRouteEnter(to, from, next) {
    store
      .dispatch("grid/getGrid", { page: 1, resourcesPerPage: 10 })
      .then(() => next());
  }
};
</script>

<style lang="scss" scoped></style>
